import { Link } from 'react-router-dom';

type UserAvatarProps = {
    user_initials: string;
    user_name: string;
};

function HeaderUserAvatar(props: UserAvatarProps) {
    return (
        <Link className="nav-link p-0" to="/user-profile" title={ props.user_name }>
            <div
                className="rounded-circle text-white d-flex align-items-center justify-content-center"
                style={{ width: "34px", height: "34px", fontWeight: 600, background: "var(--vc-primary)" }}>
                { props.user_initials }
            </div>
        </Link>
    );
}

export default HeaderUserAvatar;